import React, { Component } from "react"
import withSizes from "react-sizes"

export default ComposedComponent => {
  class WrapperComponent extends Component {
    render() {
      return <ComposedComponent {...this.props} />
    }
  }
  const mapSizesToProps = ({ width }) => ({
    isMobile: width < 480,
    isDesktopAndGreater: width >= 832
  })
  return withSizes(mapSizesToProps)(WrapperComponent)
}



// WEBPACK FOOTER //
// ./src/hocs/with-sizes.hoc.js